<header class="ui large secondary borderless menu" #nav>
  <div class="ui container">
    <a class="header" href="/">
      <img src="assets/images/logo.svg" class="company-logo" />
    </a>
    <div class="right menu">
      <a class="item d-none-xs-sm">
        <a
          href="https://dribbble.com/indianpix"
          target="_blank"
          class="ui link-icon-btn icon circular large button"
        >
          <i class="dribbble icon"></i>
        </a>
        <a
          href="https://dribbble.com/indianpix"
          target="_blank"
          class="ui link-icon-btn icon circular large button"
        >
          <i class="behance icon"></i>
        </a>
        <a
          href="mailto:hello@indianpix.co"
          target="_blank"
          class="ui link-icon-btn icon circular large button"
        >
          <i class="envelope outline icon"></i>
          hello@indianpix.co
        </a>
      </a>
      <a class="item separator-gray d-none-xs-sm">
        <a class="ui primary circular button" href="/contact"> Contact </a>
      </a>
      <a class="item fixed-burger-btn">
        <div class="burger-ctnr">
          <div
            class="burger-button ui icon secondary massive circular button"
            [ngClass]="{ active: menuPopup }"
            (click)="navToggle()"
          >
            <div class="burger-line"></div>
          </div>
        </div>
      </a>
    </div>
  </div>
</header>

<div class="burger-menu-wrap" [ngClass]="{ active: menuPopup }">
  <div class="ui full-height container">
    <div class="ui middle aligned computer-only full-height grid">
      <div class="nine-wide column">
        <div class="ui top attached inverted no border segment">
          <a>
            <img src="assets/images/inverted-logo.svg" />
          </a>
          <h5 class="ui inverted fw-500 mt-0 header">
            Start a conversationm
            <button class="ui secondary tertiary button">
              hello@indianpix.co
            </button>
          </h5>
        </div>
        <div class="ui very padded attached inverted no border segment"></div>
        <div
          class="
            ui
            bottom
            attached
            inverted
            navigation-bottom
            no
            border
            segment
          "
        >
          <p>We are available here</p>
          <div class="ui inverted horizontal massive mt-0 list">
            <a
              href="https://dribbble.com/indianpix"
              target="_blank"
              class="item"
            >
              <i class="dribbble large icon"></i>
            </a>
            <a
              class="item"
              href="https://dribbble.com/indianpix"
              target="_blank"
            >
              <i class="behance large icon"></i>
            </a>
            <a href="https://medium.com/@indianpix" class="item">
              <i class="medium m large icon"></i>
            </a>
            <a
              class="item"
              href="https://www.linkedin.com/in/indian-pix-13b533209"
              target="_blank"
            >
              <i class="linkedin in large icon"></i>
            </a>
            <a
              href="https://www.instagram.com/indianpix.design/"
              target="_blank"
              class="item"
            >
              <i class="instagram large icon"></i>
            </a>
            <a
              href="https://www.facebook.com/indianpix.agency"
              target="_blank"
              class="item"
            >
              <i class="facebook f large icon"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="seven-wide column">
        <div class="ui menu-items inverted secondary vertical big menu">
          <ng-container *ngTemplateOutlet="navLink"></ng-container>
        </div>
      </div>
    </div>
    <div class="ui mobile-only grid">
      <ng-container *ngTemplateOutlet="mobileSlideMenu"></ng-container>
    </div>
    <div class="ui tablet-only grid">
      <ng-container *ngTemplateOutlet="mobileSlideMenu"></ng-container>
    </div>
  </div>
</div>
<ng-template #navLink>
  <a class="item" title="Home" href="/"> Home </a>
  <a class="item" href="/about"> About </a>
  <a class="item" href="/services" title="services"> Service </a>
  <a class="item" href="/career" title="services"> Career </a>
  <a class="item" href="/contact" title="Contact"> Contact </a>
  <a class="item" href="/portfolio" title="Portfolio"> Portfolio </a>
</ng-template>
<ng-template #mobileSlideMenu>
  <div class="sixteen-wide column">
    <div>
      <img src="assets/images/inverted-logo.svg" alt="" />
    </div>
    <div class="ui menu-items inverted secondary vertical big menu">
      <ng-container *ngTemplateOutlet="navLink"></ng-container>
    </div>
    <p><span class="ui white text">We are available here</span></p>
    <div class="ui horizontal social-icon-list massive mt-0 inverted list">
      <a class="item" href="https://dribbble.com/indianpix" target="_blank">
        <i class="dribbble small green icon"></i>
      </a>
      <a class="item" href="https://dribbble.com/indianpix" target="_blank">
        <i class="behance small green icon"></i>
      </a>
      <a class="item" href="https://medium.com/@indianpix" target="_blank">
        <i class="medium small green icon"></i>
      </a>
      <a
        class="item"
        href="https://www.linkedin.com/in/indian-pix-13b533209"
        target="_blank"
      >
        <i class="linkedin small green icon"></i>
      </a>
      <a
        href="https://www.instagram.com/indianpix.design/"
        target="_blank"
        class="item"
      >
        <i class="instagram small green icon"></i>
      </a>
      <a
        href="https://www.facebook.com/indianpix.agency"
        target="_blank"
        class="item"
      >
        <i class="facebook small green icon"></i>
      </a>
    </div>
    <div
      class="
        ui
        no
        radius
        green
        inverted
        center
        aligned
        fixed
        bottom
        contect-section-fixed-bottom
        m-0
        attached
        segment
      "
      routerLink="/contact"
    >
      <button class="ui primary tertiary large button" routerLink="/contact">
        Get In Touch
      </button>
    </div>
  </div>
</ng-template>
